import React from 'react'
import fp from 'lodash/fp'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import * as styles from './styles'
import * as outerStyles from '../../styles'

const EMPTY_STRING = ''
const getName = fp.getOr(EMPTY_STRING, 'file.name')

const FileInputComponent = ({
  id,
  accept,
  disabled,
  className,
  onBlur,
  onInternalChange,
  value = '',
  ...props
}) => {
  return (
    <>
      <div
        css={[outerStyles.input(props), styles.fileContainer(disabled)]}
        className={className}
      >
        <input
          id={id}
          accept={accept}
          disabled={disabled}
          css={styles.fileInput}
          type="file"
          value={value || EMPTY_STRING}
          onBlur={onBlur}
          onChange={onInternalChange}
        />
        <span css={styles.label(!!value)}>
          {getName(value) || props.placeholder}
        </span>
        {!disabled && <FontAwesomeIcon icon="file" />}
      </div>
    </>
  )
}

FileInputComponent.propTypes = {
  id: PropTypes.string,
  accept: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onInternalChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.any,
  placeholder: PropTypes.string,
}

export default FileInputComponent
